import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {

  companyOrderDetailsState = new Map<number, boolean>();
  companyStyleDetailsState = new Map<number, boolean>();

  constructor() { }
}
